<template>
  <div class="date-column" @click="openPicker">
    <!-- 1) рисуем «31 мая» -->
    <div class="date-big">{{ dayLabel }}</div>
    <div
      class="date-weekday"
      :class="{ weekend: isWeekend }"
    >
      {{ weekdayLabel }}
    </div>
    <!-- 2) рисуем «2025» -->
    <div class="date-year">{{ yearLabel }}</div>


    <!-- 3) transparent el-date-picker, растянутый на весь блок, чтобы ловить клик -->
    <el-date-picker
      ref="picker"
      v-model="internalDate"
      type="date"
      format="DD.MM.YYYY"
      value-format="YYYY-MM-DD"
      @change="onDateChange"
      class="date-picker-overlay"
      style="position: absolute!important;
  left: 0; top: 0;
  width: 100%; height: 100%;
  opacity: 0;
  z-index: 2;
  pointer-events: none;"
    />
  </div>
</template>

<script>
export default {
  name: 'DateColumn',
  props: {
    // В родителе (Calendar.vue) делаем <DateColumn v-model="selectedDate" />.
    // Сюда придёт строка типа "2025-05-31".
    modelValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // Если из props ничего не пришло, ставим сегодня (ISO)
      internalDate: this.modelValue || new Date().toISOString().slice(0, 10)
    }
  },
  watch: {
    // Если родитель вручную поменял modelValue, синхронизируем internalDate.
    modelValue(newVal) {
      if (newVal && newVal !== this.internalDate) {
        this.internalDate = newVal
      }
    }
  },
  computed: {
    weekdayLabel() {
      if (!this.internalDate) return ''
      const d = new Date(this.internalDate)
      if (isNaN(d.getTime())) return ''
      const weekdays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
      return weekdays[d.getDay()]
    },
    isWeekend() {
      if (!this.internalDate) return false
      const d = new Date(this.internalDate)
      if (isNaN(d.getTime())) return false
      return d.getDay() === 0 || d.getDay() === 6
    },
    // «DD MMM» на русском (например, "31 мая")
    dayLabel() {
      if (!this.internalDate) return ''
      const d = new Date(this.internalDate)
      if (isNaN(d.getTime())) return ''
      const day = String(d.getDate()).padStart(2, '0')
      const months = [
        'янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл',
        'авг', 'сен', 'окт', 'ноя', 'дек'
      ]
      return `${day} ${months[d.getMonth()]}`
    },
    // «YYYY»
    yearLabel() {
      if (!this.internalDate) return ''
      const d = new Date(this.internalDate)
      if (isNaN(d.getTime())) return ''
      return d.getFullYear()
    }
  },
  methods: {
    onDateChange(newDate) {
      // newDate уже будет точно в формате "YYYY-MM-DD"
      if (!newDate) return
      this.internalDate = newDate
      this.$emit('update:modelValue', newDate)
    },
    openPicker() {
      const picker = this.$refs.picker
      if (picker && typeof picker.handleOpen === 'function') {
        picker.handleOpen()
      }
    }
  }
}
</script>

<style scoped>
.date-column {
  height: 100px;
  width: 80px;
  background: #fafafa;
  border-right: 1px solid #e0e0e0;
  text-align: center;
  cursor: pointer;
  user-select: none;
  padding-top: 8px;
  position: relative;
  box-sizing: border-box;
}

/* «31 мая» */
.date-big {
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 2px;
}

/* «2025» */
.date-year {
  font-size: 14px;
  color: #777;
  margin-bottom: 6px;
}

/* Скрываем сам input календаря, но он остаётся кликабельным */
.date-picker-overlay {
  position: absolute!important;
  left: 0; top: 0;
  width: 100%; height: 100%;
  opacity: 0;
  z-index: 2;
  pointer-events: none; /* чтобы не мешал клику по блоку */
}
.date-weekday {
  font-size: 20px;
  color: #5a8fef;
  margin-bottom: 3px;
  font-weight: 600;
}

.date-weekday.weekend {
  color: #e53935;
  font-weight: 700;
}
</style>